import { render, staticRenderFns } from "./ShowCoupons.vue?vue&type=template&id=2795e31a&"
import script from "./ShowCoupons.vue?vue&type=script&lang=js&"
export * from "./ShowCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports